/**
 * Hand bytes to the browser as a file download.
 *
 * The object URL is revoked on a delay, not immediately: some browsers resolve
 * the download from the URL AFTER `click()` returns, and a revoked URL is a
 * download that silently produces nothing.
 */
export function downloadBytes(filename, bytes, mime) {
  const url = URL.createObjectURL(new Blob([bytes], { type: mime }));
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.rel = 'noopener';
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export default downloadBytes;
